import { createStyles } from 'antd-style';

export const useCollapsibleStyles = createStyles(() => ({
  animatedCollapsible: {
    overflow: 'hidden',
    transition: 'height 300ms ease-in-out',
  },
}));
